import { render, staticRenderFns } from "./ServerLCD.vue?vue&type=template&id=39e96c8f&"
import script from "./ServerLCD.vue?vue&type=script&lang=js&"
export * from "./ServerLCD.vue?vue&type=script&lang=js&"
import style0 from "./ServerLCD.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports